import { render, staticRenderFns } from "./ActionPostbackAssignStaff.vue?vue&type=template&id=213ca460&scoped=true&"
import script from "./ActionPostbackAssignStaff.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackAssignStaff.vue?vue&type=script&lang=js&"
import style0 from "./ActionPostbackAssignStaff.vue?vue&type=style&index=0&id=213ca460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ca460",
  null
  
)

export default component.exports